"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
class InsuranceLicense {
    constructor(active, type, licensee, number, expirationDate, nationalProducerNumber) {
        this.active = active;
        this.type = type;
        this.licensee = licensee;
        this.number = number;
        this.expirationDate = expirationDate;
        this.nationalProducerNumber = nationalProducerNumber;
    }
    static fromObj(data) {
        if (data.type) {
            const { active, type, licensee, number, expirationDate, nationalProducerNumber } = data;
            return new InsuranceLicense(!!active, type, licensee, number !== null && number !== void 0 ? number : "", expirationDate !== null && expirationDate !== void 0 ? expirationDate : "", nationalProducerNumber);
        }
        const { active, owner, licenseNumber } = data;
        let licensee = owner !== null && owner !== void 0 ? owner : "";
        if (licensee.toLowerCase().startsWith("ursus")) {
            licensee = "Ursus Insurance Services Inc.";
        }
        return new InsuranceLicense(active !== false, types_1.defaultInsuranceLicenseTypes.EXCESS_LINES_LICENSEE, licensee, licenseNumber !== null && licenseNumber !== void 0 ? licenseNumber : "", "");
    }
}
exports.default = InsuranceLicense;
//# sourceMappingURL=insuranceLicense.class.js.map